import { getStageWidthByAspectRatio } from './index';

function getStageWidth(
  pageHeight,
  pageWidth,
  maxWidth,
  otherElementsButStageHeightAndSourceList,
  sourceListHeight
) {
  // stageHeight is variable, so it is calculated as the other elements on the page
  // (header, layout, sourceList(which is also variable))
  // subtracted from the fullPage height
  const widthByAspectRatio = getStageWidthByAspectRatio(
    pageHeight,
    otherElementsButStageHeightAndSourceList,
    sourceListHeight
  );

  if (pageWidth <= 860) {
    // when page size is past the breakpoint, it should use either the maxWidth or widthByAspectRatio depending on whether
    // widthByAspectRatio is more than the maxWidth, it should use the maxWidth
    return widthByAspectRatio >= maxWidth ? maxWidth : widthByAspectRatio;
  } else if (maxWidth <= widthByAspectRatio) {
    // if widthByAspectRatio is more than the maxWidth, it should use the maxWidth
    return maxWidth;
  } else if (pageWidth <= widthByAspectRatio) {
    // if the widthByAspectRatio is more than the width of the whole Page, it should use pageWidth - 30 (padding)
    return pageWidth - 30;
  } else {
    // in regular conditions, the width is the one calculated using the aspect ratio
    return widthByAspectRatio;
  }
}

export default getStageWidth;
